import React from 'react'
import { connect, useSelector } from 'react-redux'
import { getUserIp } from './hotelServices'
import { fetchMuvRoomsWithRetry } from '../../../utility/utility'
import * as Actions from '../../../redux/actions'

const Policies_ = ({ establishment, hotel_form_state, fetchMuvRooms }) => {
    const { generalInfo } = establishment
    const { allowed_cards_data, check_in_time, check_out_time, } = generalInfo

    const [expContent, setExpContent] = React.useState()

    var searchParams = new URLSearchParams(document.location.search.substring(1));
    const findBy = searchParams.get("findBy")
    const selectedCurrency = useSelector(state => state.Setting.currency.selected.shortCode);
    const isMobile = useSelector(state => state.Setting.is_mobile);
    const uuid = useSelector(state => state.Member.authModal.uuid);
    const fullCurrency = selectedCurrency ? selectedCurrency.toUpperCase() : "CAD";


    React.useEffect(() => {
        const getHotelDetails = async () => {

            if (establishment?.generalInfo?.establishmentPricelineID && findBy === "exp") {
                const ipAddress = await getUserIp();
                const data = {
                    muv_hotel_id: establishment?.generalInfo?.establishmentPricelineID,
                    check_in: hotel_form_state?.check_in,
                    check_out: hotel_form_state?.check_out,
                    provider: 'exp',
                    adults: hotel_form_state?.adults || 1,
                    rooms: hotel_form_state?.rooms || 1,
                    children: 0,
                    currency: fullCurrency,
                    userIp: ipAddress || "138.1.1.1",
                    userAgent: navigator?.userAgent || "MUV",
                    customerPlatform: isMobile ? "mobile" : "web",
                    uuid: uuid
                }
                const response = await fetchMuvRoomsWithRetry(fetchMuvRooms, data);
                const expContent = response?.muvHotelData?.expContent ? Object.values(response?.muvHotelData?.expContent)?.[0] : null;
                setExpContent(expContent)

            }


        }
        getHotelDetails()
    }, [establishment])


    return (
        <div>
            <div>
                <div style={{ display: "inline-block", width: "50%", height: "auto", textAlign: 'justify', paddingRight: 40 }}>
                    <div style={{ font: "24px/36px Futura Hv BT", color: "#191919", marginBottom: "30px", }}>Policies</div>

                    <div style={{ font: "18px/24px Futura Hv BT", color: "#191919", marginBottom: "10px", }}>Check-in</div>
                    {expContent?.checkin?.begin_time && <div style={{ font: "16px/22px Futura Lt BT", color: "#929292", }}>
                        Check-in time starts at {expContent?.checkin?.begin_time}</div>}
                    <div style={{ font: "16px/22px Futura Lt BT", color: "#929292", }}>
                        Check-in time ends at midnight</div>
                    {expContent?.checkin.instructions && <div>
                        <div style={{ font: "18px/24px Futura Hv BT", color: "#191919", marginBottom: "10px", marginTop: 10 }}>Instructions</div>
                        <div dangerouslySetInnerHTML={{ __html: expContent?.checkin.instructions }} style={{ font: "16px/22px Futura Lt BT", color: "#929292", }}>
                        </div>
                    </div>}

                    {expContent?.checkin.special_instructions && <div>
                        <div style={{ font: "18px/24px Futura Hv BT", color: "#191919", marginBottom: "10px", }}>Special Instructions</div>
                        <div dangerouslySetInnerHTML={{ __html: expContent?.checkin.special_instructions }} style={{ font: "16px/22px Futura Lt BT", color: "#929292", }}>
                        </div>
                    </div>}

                    {expContent?.fees?.mandatory && <div>
                        <div style={{ font: "18px/24px Futura Hv BT", color: "#191919", marginBottom: "10px", marginTop: "10px", }}>Mandatory Fees</div>
                        <div dangerouslySetInnerHTML={{ __html: expContent?.fees?.mandatory }} style={{ font: "16px/22px Futura Lt BT", color: "#929292", }}>
                        </div>
                    </div>}

                    {expContent?.fees?.optional && <div>
                        <div style={{ font: "18px/24px Futura Hv BT", color: "#191919", marginBottom: "10px", marginTop: "10px", }}>Optional Fees</div>
                        <div dangerouslySetInnerHTML={{ __html: expContent?.fees?.optional }} style={{ font: "16px/22px Futura Lt BT", color: "#929292", }}>
                        </div>
                    </div>}



                    <div style={{ font: "18px/24px Futura Hv BT", color: "#191919", marginBottom: "10px", marginTop: "10px", }}>Check-out</div>
                    {expContent?.checkout?.time && <div style={{ font: "16px/22px Futura Lt BT", color: "#929292", marginBottom: "10px", }}>
                        Check-out time is {expContent?.checkout?.time}</div>}

                    <div style={{ font: "18px/24px Futura Hv BT", color: "#191919", marginBottom: "10px", }}>Children and extra beds</div>
                    <div style={{ font: "16px/22px Futura Lt BT", color: "#929292", }}>
                        Children are welcome { }</div>
                    <div style={{ font: "16px/22px Futura Lt BT", color: "#929292", }}>
                        Free cribs (infant beds) { }</div>

                    {allowed_cards_data && <div style={{ font: "18px/24px Futura Hv BT", color: "#191919", marginBottom: "10px", marginTop: "10px", }}>Payment types</div>}
                    <div style={{ font: "16px/22px Futura Lt BT", color: "#929292", marginBottom: "10px", }}>
                        {allowed_cards_data !== undefined && allowed_cards_data.map((card, idx) => {
                            return <li key={idx}>{card.name}</li>
                        })}
                    </div>





                </div>
                <div style={{ display: "inline-block", width: "45%", height: "auto", verticalAlign: "top", textAlign: 'justify', }}>
                    <div style={{ font: "24px/36px Futura Hv BT", color: "#191919", marginBottom: "30px", }}>Important Information</div>

                    <div style={{ font: "18px/24px Futura Hv BT", color: "#191919", marginBottom: "10px", }}>Optional Extras</div>
                    <div style={{ font: "16px/22px Futura Lt BT", color: "#929292", }}>
                        The following fees and deposits sre charged by the property at the time of service, check-in, check-out.
                    </div>
                    <div style={{ font: "16px/22px Futura Lt BT", color: "#929292", }}>
                        {generalInfo.rate_amenity_data !== undefined && generalInfo.rate_amenity_data !== null && generalInfo.rate_amenity_data.map((amenity, idx) => {
                            return <li key={idx}>{amenity.name}</li>
                        })}
                    </div>
                    <div style={{ font: "16px/22px Futura Lt BT", color: "#929292", }}>
                        The above list may not be comprehensive.  Fees and deposits may not include tax and are subject to change.
                    </div>

                    <div style={{ font: "18px/24px Futura Hv BT", color: "#191919", marginBottom: "10px", marginTop: "10px", }}>You need to know</div>

                    {!expContent && <div>
                        <div style={{ font: "16px/22px Futura Lt BT", color: "#929292", }}>
                            Extra person charges may apply and vary depending on property policy.</div>
                        <div style={{ font: "16px/22px Futura Lt BT", color: "#929292", }}>
                            Government-issued photo identification and a credit card, debit card, or cash deposit are required at check-in for incidental charges.</div>

                        <div style={{ font: "16px/22px Futura Lt BT", color: "#929292", }}>
                            Special requests are subject to availability upon check-in and may incur additional charges.  Special requests cannot be guaranteed.</div>
                    </div>}


                    {expContent?.policies?.know_before_you_go &&
                        <div dangerouslySetInnerHTML={{ __html: expContent?.policies?.know_before_you_go }} style={{ font: "16px/22px Futura Lt BT", color: "#929292", }}>
                        </div>}




                    {false && <div style={{ font: "18px/24px Futura Hv BT", color: "#191919", marginBottom: "10px", }}>We should mention</div>}


                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({

    establishment: state.FormBank.HotelSearch.establishment,
    isMobile: state.Setting.is_mobile,
    lang: state.Setting.lang,
    uuid: state.Member.authModal.uuid,
    hotel_form_state: state.FormBank.HotelSearch.hotel_form_state,
    switchFeatureContainer: state.FormBank.FeatureFormat,
})

const mapDispatchToProps = {
    fetchMuvRooms: Actions.fetchMuvRooms,
}

const Policies = connect(mapStateToProps, mapDispatchToProps)(Policies_)
export default Policies
